import { useApi } from '@/api/useApi.ts';
import { IConversationSummary } from '@/interfaces/deltaGpt/IConversationSummary.ts';
import { IUserAiHistory } from '@/interfaces/deltaGpt/IUserAiHistory.ts';

const apiCall = useApi('deltaGpt');

async function GetUsersConversationSummary (): Promise<Array<IConversationSummary>> {
    const endpoint = '/GetUsersConversationSummary';
    return (await apiCall.get<Array<IConversationSummary>>({ endpoint })).data;
}

async function getChatMessageHistoryById (conversationId: string): Promise<Array<IUserAiHistory>> {
    const endpoint = `/GetChatMessageHistoryById/${conversationId}`;
    return (await apiCall.get<Array<IUserAiHistory>>({ endpoint })).data;
}

export const deltaGptHistoryApi = {
    GetUsersConversationSummary,
    getChatMessageHistoryById,
};
